import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Reality } from './components/Reality';
import { Origin } from './components/Origin';
import { Framework } from './components/Framework';
import { Research } from './components/Research';
import { Programming } from './components/Programming';
import { Partnerships } from './components/Partnerships';
import { Summit } from './components/Summit';
import { Founder } from './components/Founder';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-soft-white selection:bg-azure/20 selection:text-deep-azure" data-id="element-0">
      <Navigation data-id="element-1" />
      <Hero data-id="element-2" />
      <Reality data-id="element-3" />
      <Origin data-id="element-4" />
      <Framework data-id="element-5" />
      <Research data-id="element-6" />
      <Programming data-id="element-7" />
      <Partnerships data-id="element-8" />
      <Summit data-id="element-9" />
      <Founder data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}